import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { MemberList } from '@gem/call/CallView/Shared/MemberList/MemberList';
import { customScrollStyles } from '@gem/ui-kit';

import styles from './MembersPanel.styles.m.css';
import { MembersPanelHeader } from './MembersPanelHeader/MembersPanelHeader';

interface IMembersPanelProps {
  call: Call;
}

export const MembersPanel: FC<IMembersPanelProps> = observer(({ call }) => {
  return (
    <div className={styles.container}>
      <MembersPanelHeader call={call} />
      <div className={classNames(styles.memberListContainer, customScrollStyles.container)}>
        <MemberList />
      </div>
    </div>
  );
});
